import React from 'react';
import { useMessagesContext } from '../../_providers/Messages';
import MessagePanel from './MessagePanel';

function MessagesContainer(props) {

    const messages = useMessagesContext();
    console.log(messages)
    return (
        messages.openChats.map((user, i) => {
            return (
                <MessagePanel
                    key={user.chatId}
                    number={i}
                    user={{
                        ...user,
                        receiver_tenant_id: user.tenant_id
                    }}
                />
            );
        })
    )

}

export default MessagesContainer;